import { useEffect, useState } from "react";
import ItemAyat from "../../components/shared/itemayat";
import { Utils } from "../../utils";

function Bookmark() {
  const [onBookmark, setOnBookmark] = useState({});

  useEffect(() => {
    const bookmark = Utils.getBookmark();
    if (bookmark) setOnBookmark(bookmark);
  }, []);

  function removeBookmark() {
    setOnBookmark({});
    Utils.removeBookmark();
  }

  return Object.keys(onBookmark).length > 0 ? (
    <div className="w-full h-full flex flex-col justify-center items-center">
      <div className="w-full flex justify-center text-hijau font-bold text-xl border-b-[1px]">
        {onBookmark.namaSurah}
      </div>
      <div className="w-full relative">
        <ItemAyat
          data={onBookmark}
          onBookmark={onBookmark}
          setBookmark={() => {}}
        />
        <div
          className="flex justify-end absolute bottom-[-12px] right-6 hover:cursor-pointer"
          onClick={() => removeBookmark()}
        >
          <img
            src="/remove.png"
            alt="remove.png"
            height={30}
            width={30}
            className="bg-white"
          />
        </div>
      </div>
    </div>
  ) : (
    <div className="w-full h-full flex justify-center items-center text-xl">
        Bookmark Kosong
    </div>
  );
}

export default Bookmark;
